import React from 'react';
import { shouldKeepThinkingVisible } from './thinkingState.js';

function resolveAssistantItems(round) {
  const orderedItems = Array.isArray(round.assistantItems) ? round.assistantItems : [];
  const processItems = Array.isArray(round.assistantProcessItems) ? round.assistantProcessItems : [];
  const outputItems = Array.isArray(round.assistantOutputItems) ? round.assistantOutputItems : [];
  if (orderedItems.length > 0) {
    return orderedItems;
  }
  return [...processItems, ...outputItems];
}

export function buildTimelineElements({
  roundEntries,
  renderItemNode,
  loading = false,
}) {
  return roundEntries.flatMap((round, roundIndex) => {
    const assistantItems = resolveAssistantItems(round);
    const hasStreamingContent = assistantItems.some((item) => (
      item.type === 'streaming' && String(item.content || '').trim()
    ));
    const blocks = [];

    if (round.userMessage) {
      const userNode = renderItemNode(round.userMessage, hasStreamingContent);
      if (userNode) {
        blocks.push(
          <React.Fragment key={`${round.key}-user-${String(round.userMessage.id || roundIndex)}`}>
            {userNode}
          </React.Fragment>
        );
      }
    }

    const latestOrchestrationStatusIndex = assistantItems.findLastIndex(
      (item) => Object.assign({}, item).type === 'orchestration_status'
    );

    const visibleAssistantItems = assistantItems.filter((item, index) => {
      const itemRecord = Object.assign({}, item);
      const hidesEarlierStatus = [
        itemRecord.type === 'orchestration_status',
        latestOrchestrationStatusIndex >= 0,
        index !== latestOrchestrationStatusIndex,
      ].every(Boolean);
      if (hidesEarlierStatus) {
        return false;
      }
      return itemRecord.type !== 'thinking' || shouldKeepThinkingVisible({ item, loading });
    });
    if (visibleAssistantItems.length > 0) {
      const turnId = `assistant:${round.key}`;
      const node = renderItemNode({ id: turnId, type: 'assistant_turn', items: visibleAssistantItems }, hasStreamingContent);
      if (node) blocks.push(<React.Fragment key={turnId}>{node}</React.Fragment>);
    }

    (Array.isArray(round.artifactItems) ? round.artifactItems : []).forEach((item, index) => {
      const node = renderItemNode(item, hasStreamingContent);
      if (!node) {
        return;
      }
      blocks.push(
        <React.Fragment key={`${round.key}-artifact-${String(item.id || index)}`}>
          {node}
        </React.Fragment>
      );
    });

    return blocks;
  });
}
